export const CbTopBaseResourcesEn = {
    registerText: "Join goodie",
    title: "Cashback - <b>money refunds for shopping</b>",
    subTitle: "Shop at your favorite online stores and get part of money you spent back.",
};
